module.exports = __webpack_public_path__ + "team-top-bw.svg?ebb4d5f344c6fee76ccfd5454ebcf094";


//////////////////
// WEBPACK FOOTER
// ./src/assets/backgrounds/team-top-bw.svg
// module id = 73
// module chunks = 0